import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { SectionHeader } from 'components/common'

import { COMPONENT_EXTENDER } from 'extender'

const HomePageLayout = COMPONENT_EXTENDER('components/layouts/HomePageLayout')
const SettingsTabs = COMPONENT_EXTENDER('components/core/Settings/SettingsTabs/SettingsTabs-component')

const SettingsPage: FC = () => {
    const { t } = useTranslation()

    return (
        <HomePageLayout page="settings">
            <SectionHeader>{t('Pages.settings.Settings')}</SectionHeader>
            <SettingsTabs />
        </HomePageLayout>
    )
}

export default SettingsPage
